export var link = "https://edusphere.co.in/";
// export var link = "http://192.168.1.144:5005/";
